module.exports = __webpack_public_path__ + "img/stopwatch-outline.42a3ff5b.svg";